import Api from "services/anythingllm/Api";

export default class AnythinglmaApi {

    chat = async (_workspace, _question, _mode) => {
        const body = { 'message': _question, 'mode': _mode };
        return await Api.post(`workspace/${_workspace}/chat`, body).then(response => response.data)
            .catch((error) => console.log('[api.categorias.index] Error\n', error));

    }
}


